import styled from '@emotion/styled';

import lookUpImage from './assets/lookUpSearchBar.svg';

export const SearchBar = styled.input`
  width: inherit;
  height: 40px;
  margin-bottom: 30px;
  font-size: 16px;
  border: 2px solid transparent;
  transition : border 200ms ease-out;
  box-sizing: border-box
  background: ${({ theme }) => theme.colors.secondary.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-image: url(${lookUpImage});
  background-size: 36px 36px;
  background-position: left center;
  background-repeat: no-repeat;
  padding-left: 40px;
  font-weight: bold;
  font-family:${({ theme }) => theme.fonts.nunitoSans};

  &:focus {
    outline: none;
    border: 2px solid #1b1b1b;
  }
`;
